import styled from 'styled-components';
import { PageWrapper } from '@innovyze/stylovyze';

export const FullPage = styled.div`
  height: 100%;
  padding: 1px;
  display: flex;
  flex-direction: column;
`;

export const FullPageWrapper = styled(PageWrapper)`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const TitleSection = styled.div`
  padding: 24px;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e0e0e0;
`;

export const ContentSection = styled.div`
  padding: 24px;
  background-color: white;
  flex: 1;
  display: flex;
  flex-direction: column;
`;
